<nav class="bg-white border-b shadow-sm sticky top-0 z-50">

  <div class="max-w-7xl mx-auto px-6">

    <div class="flex items-center justify-between h-16 gap-6">

      <!-- Logo -->
      <a routerLink="/home"
         class="text-2xl font-extrabold tracking-wide text-indigo-600">
        ShopNest
      </a>

      <!-- Search -->
      <div class="hidden md:flex flex-1 max-w-xl">

      <div class="hidden md:flex flex-1 max-w-xl relative">

<input
type="text"
[(ngModel)]="keyword"
(keyup)="onTyping()"
(keyup.enter)="search()"
placeholder="Search products..."
class="w-full px-4 py-2 border border-gray-300 rounded-l-lg focus:ring-2 focus:ring-indigo-500 focus:outline-none"
/>

<button
(click)="search()"
class="bg-indigo-600 text-white px-5 rounded-r-lg hover:bg-indigo-700 transition">
🔍
</button>

<!-- Suggestions -->
<div
*ngIf="showSuggestions"
class="absolute top-12 w-full bg-white border rounded-lg shadow-lg z-50">

<div
*ngFor="let s of suggestions"
(click)="openProduct(s.id)"
class="flex items-center gap-3 px-4 py-2 hover:bg-gray-100 cursor-pointer">

<img
[src]="s.imageUrl"
class="w-8 h-8 object-cover rounded"
/>

<span class="text-sm">
{{s.name}}
</span>

</div>

</div>

</div>

      </div>

      <!-- Menu -->
      <div class="hidden md:flex items-center gap-8 text-gray-700 font-medium">

        <a routerLink="/home"
           class="hover:text-indigo-600 transition">
          Home
        </a>

        <a *ngIf="auth.isUser()"
           routerLink="/cart"
           class="hover:text-indigo-600 transition">
          Cart
        </a>

        <a *ngIf="auth.isUser()"
           routerLink="/account/wishlist"
           class="hover:text-indigo-600 transition">
          Wishlist
        </a>

        <a *ngIf="auth.isUser()"
           routerLink="/gift"
           class="hover:text-indigo-600 transition">
          🎁 Rewards
        </a>

        <a *ngIf="auth.isAdmin()"
           routerLink="/admin/products"
           class="hover:text-indigo-600 transition">
          Admin
        </a>

      </div>

      <!-- Right Side -->
      <div class="flex items-center gap-4">

        <a routerLink="/account"
           class="hidden md:flex items-center gap-2 text-gray-700 hover:text-indigo-600 transition">
          👤 Profile
        </a>

        <button
          (click)="logout()"
          class="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg transition">
          Logout
        </button>

      </div>

    </div>

  </div>

</nav>